import { render, staticRenderFns } from "./RematchFailStep.vue?vue&type=template&id=35b485b3"
import script from "./RematchFailStep.vue?vue&type=script&lang=js"
export * from "./RematchFailStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports